import { useTranslation } from 'react-i18next';

import { useDownloadDocument } from '@/features/documents/hooks/use-download-document';
import { DocumentState } from '@/features/projects/kpi-tracking-entry/hooks/use-document-manager';
import FileIcon from '@/shared/assets/document.svg?react';
import PlusIcon from '@/shared/assets/plus.svg?react';
import XIcon from '@/shared/assets/xmark_filled.svg?react';
import { Button } from '@/shared/components/ui/button';

interface DocumentsListProps {
  documents: DocumentState[];
  onRemoveDocument: (documentId?: number, tempId?: string) => void;
  onAddDocument: () => void;
  editMode?: boolean;
  onEditDocument?: (document: DocumentState) => void;
  isContractor?: boolean;
}

export const TrackingReportDocumentsList = ({
  documents,
  onRemoveDocument,
  onAddDocument,
  onEditDocument,
  isContractor,
}: DocumentsListProps) => {
  const { t } = useTranslation('project', {
    keyPrefix: 'TrackingReports.TrackingReportsDialog',
  });

  const { mutate: downloadDocument } = useDownloadDocument();

  return (
    <div>
      {documents && documents.length > 0 && (
        <div
          className={`mb-4 max-h-[150px] space-y-2 overflow-y-auto ${documents.length > 3 ? 'pr-4' : ''}`}
        >
          {documents.map((document, index) => {
            return (
              <div
                key={document.id || document.tempId || index}
                className={`flex items-center justify-between rounded-2xs border border-white/10 bg-white/5 px-4 py-2 text-white`}
              >
                <div
                  className="flex min-w-0 flex-1 cursor-pointer items-center space-x-2"
                  onClick={() => {
                    if (isContractor) {
                      onEditDocument?.(document);
                    } else {
                      if (document.metadata.file_path) {
                        downloadDocument(document.metadata.file_path);
                      }
                    }
                  }}
                >
                  <FileIcon className="size-5 flex-shrink-0" />
                  <span className="truncate text-sm">{document.title}</span>
                </div>
                {isContractor && (
                  <XIcon
                    className="ml-3 size-5 flex-shrink-0 cursor-pointer"
                    onClick={() => {
                      onRemoveDocument(document.id, document.tempId);
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
      {isContractor && (
        <div className="flex justify-end">
          <Button
            variant="outline"
            btnType="secondary"
            className="font-[510]"
            onClick={onAddDocument}
          >
            <PlusIcon className="!size-5" />
            {t('add_document')}
          </Button>
        </div>
      )}
    </div>
  );
};
